import {Dismissible} from "@khan/component-dismissible";
import {useFlagsCookie} from "@khan/data-cookies";

import AskKhanmigo from "./ask-khanmigo.tsx";

const EditorTutorial = (): JSX.Element => {
    const flagResult = useFlagsCookie("editor-tutorial");
    const getKhanmigo =
        (flagResult.status === "success" ? flagResult.value : undefined) ??
        false;

    if (getKhanmigo) {
        return <AskKhanmigo />;
    }

    return (
        <Dismissible
            dismissKey="khanmigo-tools-editor-tutorial"
            expiresDays="never"
            showOnce={false}
        >
            {(dismiss) => <AskKhanmigo dismiss={dismiss} />}
        </Dismissible>
    );
};

export default EditorTutorial;
